<template>
  <div class="container">
    <Header></Header>
    <HeaderMobile></HeaderMobile>
    <div class="rp-container">
      <div class="rp-right">
        <div class="rp-right-overlay"></div>

        <AuthCardTwo
          head="New Here?"
          subhead="Get ready to kiss your captcha troubles goodbye."
          buttonText="Create An Account"
          @clicked="handleCreateAccount"
        ></AuthCardTwo>
      </div>
      <div class="rp-left">
        <h1>Reset Your Password</h1>

        <div class="auth-input-section">
          <InputWidget @changed="handleEmailChanged" :isPassword=false placeholder="Email Address"></InputWidget>
         
          <ButtonFilled @onButtonClicked="sendPasswordLink" :text="btnStatus"></ButtonFilled>
          <div class="error-message" v-html="errorMessage"></div>
          <div class="success-message" v-html="successMessage"></div>
          
        </div>
      </div>
    </div>
  </div>
</template>

<!-- eslint-disable -->

<script>
import AuthHead from "../../../components/auth/AuthHead";
import AuthCardTwo from "../../../components/auth/AuthCardTwo";
import InputWidget from "../../../components/common/InputWidget";
import ButtonFilled from "../../../components/common/ButtonFilled";
import ThirdParty from "../../../components/auth/ThirdParty";
import CheckBox from "../../../components/common/Checkbox";
import ButtonOutlinedScroll from "../../../components/common/ButtonOutlinedScroll";
import Header from "../../../components/landing/Header";
import HeaderMobile from "../../../components/landing/HeaderMobile";
import { handleForgotPassword } from "../../../service/user";

export default {
  components: {
    AuthHead,
    AuthCardTwo,
    InputWidget,
    ButtonFilled,
    ThirdParty,
    CheckBox,
    ButtonOutlinedScroll,
    Header,
    HeaderMobile,
  },
  data() {
    return {
      headline: "",
      email: "",
      password: "",
      btnStatus: "Submit",
      rememberMe: false,
      errorMessage: "",
      successMessage: ""
    };
  },

  mounted() {
    window.scroll(0, 0);
  },

  methods: {
    validateEmail(emailField) {
      var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
      if (reg.test(emailField) == false) {
        return false;
      }
      return true;
    },

    scrollDown() {
      window.scrollTo(0, document.body.scrollHeight);
    },
    handleCreateAccount() {
      this.$router.push({ name: "register" });
    },
    handleEmailChanged(email) {
      this.email = email;
    },
    
    checkChanged(check) {
      this.rememberMe = check;
    },
    async sendPasswordLink() {
      this.errorMessage = "";
      this.successMessage = ""
      if (
        this.validateEmail(this.email)
      ) {
        this.btnStatus = "Wait...";
        try {
          const res = await handleForgotPassword(
            this.email,
          );

          if (res.data.code == 200) {
            this.successMessage = 'A reset link has been sent to your email'
            this.btnStatus = 'Submit'
          } else {
            this.btnStatus = "Submit";
            this.errorMessage = res.data.message;
          }
        } catch (e) {
          this.btnStatus = "Submit";
          this.errorMessage = e.message;
        }
      } else {
        if (!this.validateEmail(this.email)) {
          this.errorMessage += "Invalid Email" + "<br/>";
        }
      }
    },
  },
};
</script>

<style scoped>
.container {
  margin: auto;
  min-height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 10px;
  width: 95%;
  height: 1000px;
  margin: auto;
  margin-top: 14px;
  margin-bottom: 14px;
}

.auth-head {
  margin-top: 25px !important;
}

.rp-container {
  background-color: #1a1c1f;
  border-radius: 7px;
  width: 976px;
  box-shadow: 2px 2px 5px #0000002a;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: radial-gradient(
    ellipse 180% 170% at top,
    #26292e 0.4%,
    #1a1c1f 100%
  );
  transition: 0.3s;
}

.rp-left {
  flex: 0.6;
  max-width: 60%;
  height: 568px;
  display: flex;
  align-items: center;
  flex-direction: column;
  transition: 0.3s;
  justify-content: center;
}

.rp-left > h1 {
  color: #e0e0e0;
  margin-bottom: 24px;
  text-align: center;
}

.rp-left > h5 {
  font-size: 12px;
  line-height: 16px;
  color: #888888;
  margin-bottom: 32px;
  text-align: center;

}

.button-filled{
    margin-top: 32px !important;
}

.rp-right {
  position: relative;
  flex: 0.4;
  max-width: 40%;
  height: 568px;

  display: flex;
  justify-content: center;
  align-items: center;
  background-image: radial-gradient(
    ellipse 300% 150% at right bottom,
    #26292e 0.04%,
    #1a1c1f 100%
  );
  border-bottom-left-radius: 25px;
  border-top-left-radius: 25px;
  transition: 0.3s;
}

.rp-right-overlay {
  position: absolute;
  background: url("../../../assets/img/dom-labs.svg");
  background-repeat: no-repeat;
  background-size: auto;
  height: 100%;
  width: 100%;
}

.login-reset-password,
.keep-me-logged-in > p {
  color: #888888;
  font-size: 12px;
  margin-top: 16px;
  text-align: center;
}

.keep-me-logged-in {
  margin-bottom: 18px;
  margin-top: 6px;
}

.auth-input-section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 60%;
}

.input-widget {
  margin-top: 0px !important;
  width: 80% !important;
}

@media only screen and (max-width: 786px) {
  #headerWeb {
    display: none !important;
  }
  #landingHeaderMobile {
    display: block !important;
  }
}

@media only screen and (max-width: 750px) {
  .rp-left,
  .rp-right {
    flex: 50% !important;
    max-width: 50% !important;
    width: 50%;
  }

  .auth-input-section {
    width: 90% !important;
  }

  input {
    width: 230px;
  }

  .rp-container {
    flex-wrap: wrap !important;
  }
}

@media only screen and (max-width: 610px) {
  .container {
    height: 100% !important;
  }
  .rp-left,
  .rp-right {
    flex: 100% !important;
    max-width: 100% !important;
    width: 100%;
  }

  .rp-right {
    border-radius: 0 !important;
    border-bottom-right-radius: 25px !important;
    border-bottom-left-radius: 25px !important;
    order: 1;
  }

  input {
    width: 230px;
  }

  .rp-container {
    flex-wrap: wrap !important;
  }

  .rp-left {
    height: 95vh;
    justify-content: center;
  }

  #rpHidden {
    display: flex !important;
    margin-top: 200px !important;
  }
}
</style>